export class InsulationMaterialSizeModel {
    _id: string;
    id: number;
    insulationMaterialId: number;
    size: number;

    constructor(_id = null,
        id = null,
        insulationMaterialId = null,
        size = null) {
            this._id = _id;
            this.id = id;
            this.insulationMaterialId = insulationMaterialId;
            this.size = size;
    }
}
